export default __webpack_public_path__ + "static/media/sound-reduction.966bdcdc.svg";